/**
 * クッキーのキーを表します。
 */
export class N407SessionStorageKey {
  //4071に戻る
  public static readonly N4071RETURN: string = 'N4071RETURN';
  //4071の検索条件項目
  public static readonly N4071KOKAIMAE: string = 'N4071KOKAIMAE';
  public static readonly N4071KOKAICHU: string = 'N4071KOKAICHU';
  public static readonly N4071KOKAISHURYO: string = 'N4071KOKAISHURYO';
  public static readonly N4071HIKOKAI: string = 'N4071HIKOKAI';
  public static readonly N4071KOKAIKIKANFROM: string = 'N4071KOKAIKIKANFROM';
  public static readonly N4071KOKAIKIKANTO: string = 'N4071KOKAIKIKANTO';
  public static readonly N4071KOKAITAISHO: string = 'N4071KOKAITAISHO';
  public static readonly N4071KOKAITAISHOHIDDEN: string = 'N4071KOKAITAISHOHIDDEN';
  public static readonly N4071KIWADO: string = 'N4071KIWADO';

  //4072に戻る
  public static readonly N4072RETURN: string = 'N4072RETURN';

  //4072の検索条件項目
  public static readonly N4072KOKAIMAE: string = 'N4072KOKAIMAE';
  public static readonly N4072KOKAICHU: string = 'N4072KOKAICHU';
  public static readonly N4072KOKAISHURYO: string = 'N4072KOKAISHURYO';
  public static readonly N4072HIKOKAI: string = 'N4072HIKOKAI';
  public static readonly N4072KOKAIKIKANFROM: string = 'N4072KOKAIKIKANFROM';
  public static readonly N4072KOKAIKIKANTO: string = 'N4072KOKAIKIKANTO';
  public static readonly N4072KOKAITAISHO: string = 'N4072KOKAITAISHO';
  public static readonly N4072KOKAITAISHOHIDDEN: string = 'N4072KOKAITAISHOHIDDEN';
  public static readonly N4072KIWADO: string = 'N4072KIWADO';

  //4072のメン画面の項目
  public static readonly N4072ID: string = 'N4072ID';
  public static readonly N4072KOKAITAISHOMAIN: string = 'N4072KOKAITAISHOMAIN';
  public static readonly N4072KOKAITAISHOHIDDENMAIN: string = 'N4072KOKAITAISHOHIDDENMAIN';
  public static readonly N4072KEISAIJOKYO: string = 'N4072KEISAIJOKYO';
  public static readonly N4072NAIYO: string = 'N4072NAIYO';
  public static readonly N4072RINKUSAKIURL: string = 'N4072RINKUSAKIURL';
  public static readonly N4072KOKAIKAISHIBI: string = 'N4072KOKAIKAISHIBI';
  public static readonly N4072KOKAISHURYOBI: string = 'N4072KOKAISHURYOBI';
  public static readonly N4072KOSHIMBANGO: string = 'N4072KOSHIMBANGO';
  public static readonly N4072UPDATENO: string = 'N4072UPDATENO';
  //4073の検索条件項目
  public static readonly N4073KOKAIMAE: string = 'N4073KOKAIMAE';
  public static readonly N4073KOKAICHU: string = 'N4073KOKAICHU';
  public static readonly N4073KOKAISHURYO: string = 'N4073KOKAISHURYO';
  public static readonly N4073HIKOKAI: string = 'N4073HIKOKAI';
  public static readonly N4073KOKAIKIKANFROM: string = 'N4073KOKAIKIKANFROM';
  public static readonly N4073KOKAIKIKANTO: string = 'N4073KOKAIKIKANTO';
  public static readonly N4073KOKAITAISHO: string = 'N4073KOKAITAISHO';
  public static readonly N4073KOKAITAISHOHIDDEN: string = 'N4073KOKAITAISHOHIDDEN';
  public static readonly N4073KIWADO: string = 'N4073KIWADO';

  //4073のメン画面の項目
  public static readonly N4073ID: string = 'N4073ID';
  public static readonly N4073KOKAITAISHOMAIN: string = 'N4073KOKAITAISHOMAIN';
  public static readonly N4073KOKAITAISHOHIDDENMAIN: string = 'N4073KOKAITAISHOHIDDENMAIN';
  public static readonly N4073KEISAIJOKYO: string = 'N4073KEISAIJOKYO';
  public static readonly N4073NAIYO: string = 'N4073NAIYO';
  public static readonly N4073RINKUSAKIURL: string = 'N4073RINKUSAKIURL';
  public static readonly N4073KOKAIKAISHIBI: string = 'N4073KOKAIKAISHIBI';
  public static readonly N4073KOKAISHURYOBI: string = 'N4073KOKAISHURYOBI';
  public static readonly N4073KOSHIMBANGO: string = 'N4073KOSHIMBANGO';

  //4074のメン画面の項目
  public static readonly N4074MOTOFLG: string = 'N4074MOTOFLG';

  public static readonly N4074KOKAITAISHO: string = 'N4074KOKAITAISHO';
  public static readonly N4074KOKAITAISHOHIDDEN: string = 'N4074KOKAITAISHOHIDDEN';
}



// WEBPACK FOOTER //
// ./src/app/modules/n407/n407-session-storage-key.ts